
// Constants
import Constants from "../constants/constants";
import constantsValidation from "../constants/validation";
import LinkName from "../constants/linkName";
import constantsStorage from '../constants/storage';
import imageCompression from "browser-image-compression";

// API
import LoginApi from '../api/Login';
import typeCode from "../constants/typeCode";

const { detect } = require('detect-browser');
const getUuid = require('uuid-by-string');

const utilsCommon = {

    /**
     * Setting storage type: storageType = localStorage, sessionStorage
     */
    storageType: 'localStorage',
    storageSession: 'sessionStorage',

    /**
     * define key storage data
     */
    storageKeyData: 'kondate-food',

    /**
     * check available Cookie and Local Storage
     * 
     * @returns Boolean
     */
    isLocalStorageCookieAvailable() {
    
        let isReturn = true;
        const test = 'test';
        try {

            // Check cookie
            let cookieStatus = navigator.cookieEnabled;
            if (!cookieStatus) {
                document.cookie = test;
                cookieStatus = document.cookie.indexOf(test) !== -1;
            }

            if (!cookieStatus) {
                throw new Error('Cookies is disabled');
            }

            // Check localStorage
            let storage = window[utilsCommon.storageType];
            storage.setItem(test, test);
            storage.removeItem(test);

            let session = window[utilsCommon.storageSession];
            session.setItem(test, test);
            session.removeItem(test);
        } catch(e) {
            isReturn = false;
        }

        return isReturn;
    },

    /**
     * Clear storage data
     */
    clearStorage(storageType = utilsCommon.storageType) {
        //if they did not define storage type not defined then throw error for developer
        if(utilsCommon.storageKeyData === undefined || storageType === undefined ) {
            throw new Error("Problem with clearing form storage: Make sure storage type is defined.");
        } else { //remove items from storage on submit
            window[storageType].clear();
        }
    },

    /**
     * delete data in storage by array keys
     * 
     * @param {array} keys 
     */
    deleteStorageByKey(keys, storageType = utilsCommon.storageType) {
        if(keys && keys.length > 0) {
            let values = JSON.parse(window[storageType].getItem(utilsCommon.storageKeyData));
            if(values){
                let key;
                for(let i = 0; i < keys.length; i++) {
                    key = keys[i];
                    if(values[key]){
                        delete values[key];
                    }
                }
                window[storageType].setItem(utilsCommon.storageKeyData, JSON.stringify(values));
            }
        }
    },

    /**
     * Get data from storage by key, formate key: key.key1.key2
     * 
     * @param {String} _key 
     * @returns mixed
     */
    getStorageDataByKey(_key, storageType = utilsCommon.storageType) {
        if (!utilsCommon.isLocalStorageCookieAvailable()) {
            return null;
        }
        //if they did not define storage type not defined then throw error for developer
        if(utilsCommon.storageKeyData === undefined || storageType === undefined ) {
            throw new Error("Problem with clearing form storage: Make sure storage type is defined.");
        }

        let data = JSON.parse(window[storageType].getItem(utilsCommon.storageKeyData));
        if(!data) return null;
        // Split using a . character
        let arrKey = _key.split('.');
        let key;
        const indxLast = arrKey.length - 1;
        for(let i = 0; i < arrKey.length; i++) {
            key = arrKey[i];
            if (data && data[key]) {
                if (i === indxLast) {
                    return data[key];
                } else {
                    data = data[key];
                }
            } else {
                return null;
            }
        }

        return null;
    },

    /**
     * Save data into storage, _key only support 2 level
     * 
     * @param {String} _key : key.subkey
     * @param {Object} _data 
     */
    saveStorageData(_key, _data, storageType = utilsCommon.storageType) {
        //if they did not define then throw error for developer
        if(utilsCommon.storageKeyData === undefined) {
            throw new Error("Storage key data is not named");
        }
    
        //same for storage type
        if(!utilsCommon.isValidStorage(storageType)){
            throw new Error("Form data-storage-type needs to be defined as sessionStorage or localStorage");
        }
    
        let storageData = JSON.parse(window[storageType].getItem(utilsCommon.storageKeyData));
        if(!storageData)  {
            storageData = {}; 
        }

        // Split using a . character
        let arrKey = _key.split('.');
        let key = arrKey[0];
        if (arrKey.length === 2) {
            let key1 = arrKey[1];
            if (!storageData[key]) {
                storageData[key] = {};
            }

            storageData[key][key1] = _data;
        } else {
            storageData[key] = _data;
        }
        
        //lastly we set our values for current form in storage as JSON string. Parsed as JSON on page load.
        window[storageType].setItem(utilsCommon.storageKeyData, JSON.stringify(storageData));
    },

    /**
     * validate storage 
     * 
     * @param {String} storageName 
     * @returns boolean
     */
    isValidStorage(storageName) {
        switch(storageName) {
            case 'localStorage':
                return true; 
            case 'sessionStorage':
                return true; 
            default:
                return false;
        }
    },

    /**
     * Get access token of user
     */
    getAccessToken(strKey) {
        strKey = (strKey) ? strKey : constantsStorage.USER_TOKEN;
        return utilsCommon.getStorageDataByKey(strKey);
    },

    /**
     * Check compatible OS
     * 
     * @returns Boolean
     */
    isCompatibleOS() {
        // get list OS setting
        const osSetting = constantsValidation.SETTING_OS;

        // Result return
        let isReturn = true;

        // Detect browser
        const browser = detect();

        // Check browser
        if (browser) {
            const {os, type} = browser;

            // Incase type is browser
            if (type === 'browser' && !osSetting.includes(os)) {
                isReturn = false;
                return isReturn;
            }
        }
        
        return isReturn;
    },

    /**
     * Check compatible IE
     *
     * @returns Boolean
     */
    isCompatibleIE() {
        const isBrowserIE = /*@cc_on!@*/false || !!document.documentMode;
        return isBrowserIE;
    },

    /**
     * Check compatible devices and browsers
     * 
     * @returns Boolean
     */
    isCompatibleBrowsers() {
        // get list browser setting
        const browserSetting = constantsValidation.SETTING_DEVICES;

        // Result return
        let isReturn = true;

        // Detect browser
        const browser = detect();

        // Check browser
        if (browser && browserSetting && browserSetting.length > 0) {
            const {name, type} = browser;
            // Incase type is browser
            if (type === 'browser' && !browserSetting.includes(name.toLowerCase())) {
                return false;          
            }
        }
        
        return isReturn;
    },

    /**
     * check IOS
     * 
     * @returns boolean
     */
    isDeviceIOS() {
        // Detect browser
        const browser = detect();

        return Constants.OS_OF_IOS_DEVICES.includes(browser.os) ;
    },

    /**
     * check Chrome OS
     * 
     * @returns boolean
     */
    isDeviceChromeOS() {
        // Detect browser
        const browser = detect();

        return Constants.OS_OF_CHROMEOS_DEVICES.includes(browser.os) ;
    },

    /**
     * check if the user is logged in
     * 
     * @returns Boolean
     */
    async isCheckLogin(objLoginApi,token) {
        let isReturn = false;
        await objLoginApi.postLoginCheck({
            lkey: token,
        }).then((response) => {
            let mounted = true;
            if(mounted){
                if(response.data){
                    if(response.data.result === Constants.RESULT.OK){
                        isReturn = true;
                    }
                }
            }
            return () => mounted = false;
        },(error)=>{

        });
        return isReturn;
    },
    
     /* check the valid of time
     * 
     * @returns Boolean
     */
     isValidTime(startTime, endTime) {
        let isReturn = false;
        let now = new Date(new Date().toLocaleString("en-US", {timeZone: "Asia/Tokyo"}));
        let hour = now.getHours();
        if((hour >= startTime) && (hour < endTime)){
            isReturn = true;
        }
        return isReturn;
    },

    /**
     * Check entrypoint for system
     * 
     * @param {String} pathname 
     */
    checkEntryPoint(pathname) {

        let isLogined = false;
        let isLoginFirst = false;
        let isTeacher = false;
        let schoolYear = false;
        if (utilsCommon.isLocalStorageCookieAvailable()){
            //set default value jp for i18nextLng
            localStorage.setItem('i18nextLng', 'jp');

            // get info login
            const userData = utilsCommon.getStorageDataByKey(constantsStorage.USER);
            if (userData) {
                isLogined = userData.lkey;
                isLoginFirst = userData.need_name_register;
                isTeacher = userData.isTeacher;
                schoolYear = userData.selected_school_year;
                const pathSelectSchoolYear = utilsCommon.checkSchoolYear(pathname);
                if (pathSelectSchoolYear) {
                    window.location = pathSelectSchoolYear;
                }
            }
        }

        const _pathLogin = LinkName.getBaseLink(LinkName.LOGIN);
        if (!isLogined && pathname !== _pathLogin) {
            utilsCommon.executeLogout(true);
        } else if (isLogined && isLoginFirst && pathname !== _pathLogin) {
            const isTeacherWithoutSchoolYear = isTeacher && !schoolYear;
            if (!isTeacherWithoutSchoolYear) {
                utilsCommon.executeLogout(true);
            }
        } else if (pathname === '/' || pathname.replace(/\/$/,"") === LinkName.PUBLIC_URL) {
            utilsCommon.executeLogout(true);
        }
    },

    /**
     * logout
     */
    async executeLogout(onlyRedirect){

        if (!onlyRedirect) {
            const userData = utilsCommon.getStorageDataByKey(constantsStorage.USER);
            if (userData?.isTeacher) {
                utilsCommon.clearStorage();
                utilsCommon.clearStorage(utilsCommon.storageSession);
            } else {
                try {
                    // call API logout
                    const accessToken = utilsCommon.getAccessToken();
                    await new LoginApi().postLogout({
                        lkey: accessToken
                    }).then((response) => {
                        if (response.data) {
                            if (response.data.result === Constants.RESULT.OK) {
                                // clear storage data
                                utilsCommon.clearStorage();
                                utilsCommon.clearStorage(utilsCommon.storageSession);
                            }
                        }
                    })
                } catch (error) {
                    // Redirect to page error
                    const _pathError = LinkName.getBaseLink(LinkName.ERROR_COMMON);
                    window.location = _pathError;
                    return;
                }
            }
        }

        // Redirect to page login
        const _pathLogin = LinkName.getBaseLink(LinkName.LOGIN);
        window.location = _pathLogin;
    },
    
    /**
     * logout
     */
     checkPullName(){
        const usedata = utilsCommon.getStorageDataByKey(constantsStorage.USER);
        if (!usedata.first_name && !usedata.family_name && usedata.need_name_register === false) {
            utilsCommon.saveStorageData(constantsStorage.USER, {...usedata, need_name_register : true});
            window.location.reload();
        }
    },

    /**
     * check school year
     */
    checkSchoolYear(pathName) {
        const usedata = utilsCommon.getStorageDataByKey(constantsStorage.USER);
        const pathSelectSchoolYear = LinkName.getBaseLink(LinkName.SELECT_SCHOOL_YEAR);
        if (!usedata.selected_school_year && usedata.isTeacher && pathName !== pathSelectSchoolYear) {
            return pathSelectSchoolYear;
        }
        return null;
    },

    /**
     * get key from src image
     * 
     * @param {String} img 
     * @returns {String}
     */
    completePhotoPath(img, isTime) {

        let _src = '';
        if (img.includes("http") || img.includes("data:")) {
            if ((img.includes("http:") || img.includes("https:")) && isTime) {
                _src = img + (img.includes("?") ? '&' : '?') + (new Date().getTime());
            } else {
                _src = img;
            }
        } else {
            _src = Constants.URL_IMAGE + img ;
            if (isTime) {
                _src += '?' + (new Date().getTime());
            }
        }

        return _src;
    },

    /**
     * check scrollbar position to show scroll button
     * 
     * @param {object} arrowUp
     * @param {object} arrowDown
     */
    checkScrollLocation(arrowUp, arrowDown) {
        document.documentElement.onwheel = (e) => {
            try {
                if (document.documentElement.scrollTop + 1 >= document.documentElement.offsetHeight - window.outerHeight) {
                    arrowDown.current.style.display = "none";
                } else {
                    if (window.innerHeight < document.documentElement.offsetHeight) {
                        arrowDown.current.style.display = "inline-block";
                    }
                }
                if (document.documentElement.scrollTop >= 1) {
                    arrowUp.current.style.display = "inline-block";
                } else {
                    arrowUp.current.style.display = "none";
                }
            } 
            catch (error) {
            }
        }
        document.documentElement.addEventListener("touchmove", (e) => {
            try {
                if (document.documentElement.scrollTop + 1 >= document.documentElement.offsetHeight - window.outerHeight) {
                    arrowDown.current.style.display = "none";
                } else {
                    arrowDown.current.style.display = "inline-block";
                }
                if (document.documentElement.scrollTop >= 1) {
                    arrowUp.current.style.display = "inline-block";
                } else {
                    arrowUp.current.style.display = "none";
                }
            } 
            catch (error) {
            }
        });
        if (document.documentElement.scrollTop !== 0) {
            arrowUp.current.style.display = "inline-block";
        }
        if (window.innerHeight < document.documentElement.offsetHeight) {
            arrowDown.current.style.display = "inline-block";
        }
    },

    /**
     * Go to end of page
     * 
     * @param {object} arrowUp
     * @param {object} arrowDown
     */
    toEndPage(arrowUp, arrowDown) {
        arrowDown.current.style.display = "none";
        arrowUp.current.style.display = "inline-block";
        document.documentElement.scrollTo({top: document.documentElement.offsetHeight, behavior: 'smooth'});
    },

    /**
     * Go to top of page
     * 
     * @param {object} arrowUp
     * @param {object} arrowDown
     */
    toTopPage(arrowUp, arrowDown) {
        arrowDown.current.style.display = "inline-block";
        arrowUp.current.style.display = "none";
        document.documentElement.scrollTo({top: 0, behavior: 'smooth'});
    },

    /**
     * 
     * remove prefix data:image/png;base64,
     * 
     * @param {String} strBase64 
     * @returns String
     */
    removePrefixForBase64Image(strBase64) {
        // data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAA9wAAAMNCAYAAABqMnyXAAAAAXNSR0IAr...
        if (!strBase64) {
            return '';
        }

        return strBase64.replace(/^data(.+)(base64,)/, '');
    },

    /**
     * get unique string 
     * 
     * @param {String} _str 
     * @returns string
     */
    getUuidHashByString(_str) {
        return getUuid(_str);
    },

    /**
     * remove prefix url images
     * 
     * @param {String} _strUrl 
     * @returns String
     */
    removeImageUrlPrefix(_strUrl) {
        if (!_strUrl) {
            return '';
        }

        const strReplace = process.env.REACT_APP_IMG_URL;
        return _strUrl.replace(strReplace, "");
    },

    /**
     * get Dimensions inner element
     * 
     * @param {Element} node 
     * @returns Object
     */
    getInnerDimensions(node, check) {
        let widthNode = window.innerWidth ;
        let heightNode = window.innerHeight ;
        let zoom = check ? 1.08 : 1.112 ;
        if (widthNode < 1024) {
            zoom = 1;
        } else if (widthNode < 1366) {
            zoom = check ? 1.025 : 1.005;
        } else if (widthNode < 1900) {
            zoom = check ? 1 : 1;
        } else if (widthNode < 2160) {
            zoom = check ? 1.03 : 1.075;
        }
        let width = heightNode < 500  ? 600 : node.clientWidth*zoom;
        let height = heightNode < 500  ? 600 : node.clientHeight*zoom;
        if (widthNode < 800) {
            width = 500;
            height = 500;
        }
        if (heightNode > widthNode) {
            width = 700;
            height = 700;
        }
        return {height: height, width: width };
    },

    /**
     * resize images
     * 
     * @param {String} strBase64 
     * @param {Int} maxWidth 
     * @param {Int} maxHeight 
     * @returns 
     */
    resizeImage(strBase64, maxWidth = 946, maxHeight = 653) {
        return new Promise((resolve) => {
            let img = new Image();
            img.src = strBase64;
            img.onload = () => {
                let canvas = document.createElement('canvas');
                const scaleH = maxHeight / img.height;
                const scaleW = maxWidth / img.width;
                const scale = (scaleH > scaleW) ? scaleW : scaleH;
            
                const _width = img.width * scale;
                const _height = img.height * scale;
                canvas.width = _width;
                canvas.height = _height;
                let ctx = canvas.getContext('2d');
                ctx.fillStyle = "#fff";   
                ctx.fillRect(0, 0, _width, _height);  
                ctx.drawImage(img, 0, 0, _width, _height);
                const _dataBase64 = utilsCommon.calculateImageSize(canvas);
                resolve(_dataBase64);
            }
        });
    },

    /**
     * reduce image size
     * 
     * @param {Object} objCanvas
     * @returns String
     */
    calculateImageSize(objCanvas, maxMb = 1) {
        const _ratio = 0.05;
        let qualityDefault = 0.92;
        let _dataBase64 = objCanvas.toDataURL('image/jpeg', qualityDefault);
        let imageFileSize = Math.round(_dataBase64.length);
        let imageFileSizeMb = imageFileSize / 1024 / 1024;
        if (imageFileSizeMb > 3) {
            qualityDefault = 0.2;
        }

        maxMb = (maxMb) ? maxMb : 1;
        while (imageFileSizeMb >= maxMb && qualityDefault > _ratio) {
            qualityDefault = qualityDefault - _ratio;
            qualityDefault = +qualityDefault.toFixed(2);
            _dataBase64 = objCanvas.toDataURL('image/jpeg', qualityDefault);
            imageFileSize = Math.round(_dataBase64.length);
            imageFileSizeMb = imageFileSize / 1024 / 1024;
        }

        if (imageFileSizeMb >= maxMb) {
            while (imageFileSizeMb >= maxMb && qualityDefault > 0.01) {
                qualityDefault = qualityDefault - 0.01;
                qualityDefault = +qualityDefault.toFixed(2);
                _dataBase64 = objCanvas.toDataURL('image/jpeg', qualityDefault);
                imageFileSize = Math.round(_dataBase64.length);
                imageFileSizeMb = imageFileSize / 1024 / 1024;
            }
        }

        return _dataBase64;
    }, 

    /**
     * reduce capacity from base64
     * 
     * @param {String} base64Str 
     * @param {Float} maxMb 
     * @returns Mixed
     */
    reduceCapacityImageFromBase64(base64Str, maxMb = 0.5, sizeHeight = null) {
        maxMb = (maxMb) ? maxMb : 0.5;
        if (!sizeHeight) {
            return base64Str;
        }
        return new Promise((resolve) => {
            const img = new Image();
            img.src = base64Str;

            let ratio = 1;
            
            img.onload = () => {
                let canvas = document.createElement('canvas');

                if (img.width > img.height) {
                    ratio = sizeHeight * Constants.TRIMMING_SIZE_UNIT / img.width;
                } else {
                    ratio = sizeHeight * Constants.TRIMMING_SIZE_UNIT / img.height;
                }
                
                const width = img.width * ratio;
                const height = img.height * ratio;
            
                canvas.width = width;
                canvas.height = height;
                let ctx = canvas.getContext('2d');
                ctx.drawImage(img, 0, 0, width, height);
                let _dataBase64 = canvas.toDataURL();

                resolve({img: _dataBase64, width: width, height: height});
            }
        });
    },

    async resizeImageTrimming(data, callback) {
        const res = await fetch(data.img);
        const blob = await res.blob();
        const file = new File([blob], "file.jpeg", { type: 'image/jpeg' });
        if (file.size < constantsValidation.SIZE_1MB) {
            callback(data.img);
            return data.img;
        }
        const options = {
            useWebWorker: true,
            fileType: "image/png",
            initialQuality: 1
        }
        imageCompression(file, options)
            .then(function (compressedFile) {
                imageCompression.getDataUrlFromFile(compressedFile).then(function (result) {
                    callback(result);
                });
            })
            .catch(function (error) {
                console.log("resizeImageTrimming" + error.message);
            });
    },

    /**
     * Check base64 image size
     * 
     * @param {String} base64Str 
     * @param {Float} maxMb 
     * @returns Boolean
     */
    checkImageBase64Size(base64Str, maxMb = 5) {
        if (!base64Str || typeof base64Str !== 'string' || !base64Str.includes('data:image')) {
            return true;
        }
        let _dataBase64 = base64Str;
        let base64Length = _dataBase64.length - (_dataBase64.indexOf(',') + 1);
        let padding = (_dataBase64.charAt(_dataBase64.length - 2) === '=') ? 2 : ((_dataBase64.charAt(_dataBase64.length - 1) === '=') ? 1 : 0);
        let fileSize = (base64Length * 0.75) - padding;
        let imageFileSizeMb = fileSize / 1024 / 1024;
        return imageFileSizeMb <= maxMb;
    },

    /**
     * create uuid
     */
    createUuidHash(_url){
        return getUuid(_url + ((new Date()).getTime().toString()) + Math.random(0, 9999999)); 
    },

    /**
     * Update MEAL-257
     * append ★ when dish is original
     * 
     */
    getNameOriginal(item){
        if(!item?.rel_dish_type) return item?.dish_name
        return item?.rel_dish_type !== typeCode.REL_DISH_TYPE.DISH ? typeCode.IS_ORIGINAL +item?.dish_name : item?.dish_name
    },
    getNameOriginalCapture(item, isSnack = false){
        if(!item?.rel_dish_type) {
            return this.limitStringLength(item?.dish_name, 17);
        }
        let dishName = item?.dish_name;
        let lengthLimit = Constants.MAX_LENGTH_DISH_CAPTURE.DISH;
        if (item?.rel_dish_type !== typeCode.REL_DISH_TYPE.DISH) {
            dishName = typeCode.IS_ORIGINAL + item?.dish_name;
            lengthLimit = Constants.MAX_LENGTH_DISH_CAPTURE.DISH_ORIGINAL;
        }
        if (isSnack) {
            lengthLimit = Constants.MAX_LENGTH_DISH_CAPTURE.SNACK;
        }
        return this.limitStringLength(dishName, lengthLimit);
    },
    checkIsOriginal(item){
        if(!item?.rel_dish_type) return false
        return item?.rel_dish_type !== typeCode.REL_DISH_TYPE.DISH
    },
    limitStringLength(str, length) {
        if (!str) {
            return '';
        }
        if (str.length > length) {
            return str.slice(0, length) + '...';
        }
        return str;
    }
}

export default utilsCommon;